import {
  KeyboardArrowDown,
  MoreHoriz,
  Search,
  CheckCircle,
  CheckCircleOutline,
} from "@material-ui/icons";
import React from "react";
import ReactSelect from "react-select";
import { Button, Col, Dropdown, Form, Row, Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PhoneNumber from "../Common/phoneNumber";
import DeletePrompt from "../Common/DeletePrompt";
import { toastMessage, checkObjExists } from "../Common/Common";
import {
  buyerAgentsAction,
  getAllOwnersData,
  removeUsersAction,
  forgotPasswordAction,
  updateBuyerUserAction,
  reActivateDeletedUserAction,
  searchUserAction,
  changeBillingPlanAction,
  getCurrentCreditAction,
  updateCurrentCreditAction,
  restoreUsersAction,
} from "./../../actions/UserActions";
import { getbillingPlans } from "./../../actions/BillingActions";
import noRecord from "./../../assets/img/no-record.png";
import * as constant from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";
import { Field, Formik, ErrorMessage } from "formik";
import _ from "lodash";
import AssignPlanForm from "./../BillingModule/BillingPlans/AssignPlanForm";
import NumericInput from "react-numeric-input";

class BuyerAgent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showArchieve: false,
      show: false,
      showDelete: "Studio Owners",
      showLoader: true,
      showSpinner: true,
      modalUserData: {},
      modalCmpnyData: {},
      users: [],
      searchedRequests: [],
      originalRequestsUsers: [],
      filteredRequestsUsers: [],
      deletePrompt: false,
      userId: "",
      recordPerPage: constant.RECORD_PER_PAGE,
      page: 0,
      editPrompt: false,
      form: {
        id: "",
        email: "",
      },
      billingPlanPrompt: false,
      creditPrompt: false,
      currentCredit: 0,
      planDetails: {},
      billingPlan: [],
      filterText:
        this.props.history.location.state != null
          ? {
              label: this.props.history.location.state.name,
              value: this.props.history.location.state.id,
            }
          : null,
      selectedPlan:
        this.props.history.location.state != null
          ? this.props.history.location.state.id
          : "",
      searchParam: "",
    };
    this.removeBuyerAgent = this.removeBuyerAgent.bind(this);
    this.assignPlan = this.assignPlan.bind(this);
  }

  columns = [
    {
      name: "Name",
      selector: "name",
      sortable: true,
      ignoreRowClick: true,
      width: "15%",
    },
    {
      name: "Studio Name",
      selector: "company",
      sortable: true,
      width: "15%",
    },
    {
      name: "Billing Plan",
      selector: "plan",
      sortable: true,
      width: "10%",
    },
    {
      name: "Phone Number",
      selector: "mobile",
      //sortable: true,
      width: "10%",
    },
    {
      name: "Email",
      selector: "email",
      sortable: true,
      width: "15%",
    },
    {
      name: "Artists",
      selector: "artists",
      sortable: true,
      width: "5%",
      center: true,
      ignoreRowClick: true,
    },
    {
      name: "Artworks",
      selector: "transactions",
      sortable: true,
      center: true,
      ignoreRowClick: true,
      width: "5%",
    },
    {
      name: "Referral Code",
      selector: "referralCode",
      sortable: true,
      width: "10%",
    },
    {
      name: "Current Credit",
      selector: "currentCredit",
      sortable: true,
      width: "5%",
    },
    {
      name: "status",
      selector: "status",
      ignoreRowClick: true,
      width: "5%",
    },
    // {
    //   name: "",
    //   selector: "active",
    //   sortable: true,
    //   width: "10%",
    //   ignoreRowClick: true,
    // },
    {
      name: "",
      selector: "action",
      right: true,
      ignoreRowClick: true,
      width: "5%",
    },
  ];

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
    this.setState({ showLoader: false });
  }

  componentWillMount() {
    this.getBuyerAgentList(this.state.page);
    this.getallBillingplan();
  }

  getallBillingplan() {
    this.setState({
      showLoader: true,
    });
    this.props.getbillingPlans().then((result) => {
      this.setState({
        billingPlan:
          Array.isArray(result.data) && result.data.length > 0
            ? result.data.filter((item) => item.isActive === true)
            : [],
        showLoader: false,
      });
    });
  }

  getBuyerAgentList(pageIndex) {
    this.props
      .getAllOwnersData(
       this.state.recordPerPage,
        pageIndex,
        this.state.selectedPlan
      )
      .then((res) => {
        this.setState({
          users: this.props.buyerAgents || [],
          originalRequestsUsers: this.props.buyerAgents || [],
          filteredRequestsUsers: this.props.buyerAgents || [],
          showSpinner: false,
        });
      })
      .catch((err) => {});
  }
  changePage = async (page) => {
    if (this.state.isSearched) {
      this.searchBuyerAgent(this.state.searchParam, page - 1);
    } else {
      this.getBuyerAgentList(page - 1);
    }
  };
  removeBuyerAgent(uId) {
    this.setState({ showLoader: true, deletePrompt: false });
    this.props.removeUsersAction(uId).then((res) => {
      if (this.props.status) {
        this.getBuyerAgentList(this.state.page);
        this.setState({ showLoader: false });
      }
    });
  }

  restoreBuyerAgent(uId) {
    this.setState({ showLoader: true });
    this.props.restoreUsersAction(uId).then((res) => {
      if (res.status === constant.OK) {
        toastMessage(
          constant.SUCCESS,
          `Studio owner restored successfully. Please assign plan.`
        );
        this.getBuyerAgentList(this.state.page);
        this.setState({ showLoader: false });
      }
    });
  }

  searchBuyerAgent(param, page = this.state.page) {
    this.props
      .searchUserAction(
        "buyeragent",
        param.trim(),
        this.state.recordPerPage,
        page,
        this.state.selectedPlan
      )
      .then((response) => {
        this.setState({
          users: response.data.data,
          showLoader: false,
        });
      })
      .catch((err) => {});
  }
  getSearchResult = _.debounce((param) => {
    this.setState({ showLoader: true });
    this.searchBuyerAgent(param);
  }, 1000);

  getDataResultlist = _.debounce((param) => {
    this.setState({ showLoader: true });
    this.getBuyerAgentList(0);
  }, 1000);

  search(param) {
    if (param == "") {
      // console.log("true-187");
      this.getDataResultlist();
      this.setState({
        page: 0,
        searchParam: param,
      });
    } else {
      this.getSearchResult(param);
      this.setState({
        searchParam: param,
        isSearched: param.trim() == "" ? false : true,
      });
    }
  }

  /**
   * @desc goto buyer agent's transactions
   */
  goToTransaction(t) {
    let data = { callfromflg: "Studio_Owner", id: t };
    localStorage.setItem("transactions", JSON.stringify(data));
    this.props.history.push({
      pathname: "/artwork",
      // transactions: t,
    });
  }

  openDeletePrompt(id) {
    this.setState({
      deletePrompt: true,
      userId: id,
    });
  }

  openEditEmailPrompt(id, newEmail) {
    this.setState({
      editPrompt: !this.state.editPrompt,
      form: {
        id,
        email: newEmail,
      },
    });
  }
  onEditEmail(e) {
    const form = this.state.form;
    form["email"] = e.target.value;
    this.setState({
      ...this.state.form,
      form,
    });
  }

  requestResetPassword(email) {
    let data = { email: email.toLowerCase() };
    this.props.forgotPasswordAction(data).then((res) => {
      if (res.status === constant.OK) {
        toastMessage(constant.SUCCESS, message.PASSWORD_RESET_LINK_SENT);
        this.setState({
          forgotSuccess: true,
        });
      }
    });
  }

  reActivateUser(userId) {
    this.props
      .reActivateDeletedUserAction(userId)
      .then((response) => {
        this.getBuyerAgentList(this.state.page);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  openCreditPrompt(id) {
    this.props.getCurrentCreditAction(id).then((res) => {
      if (res.status === constant.OK) {
        this.setState({ currentCredit: res.data.currentCredit });
      }
    });
    this.setState({
      creditPrompt: !this.state.creditPrompt,
      userId: id,
    });
  }

  openChangeBillingPlan(id) {
    this.setState({
      billingPlanPrompt: !this.state.billingPlanPrompt,
      userId: id,
    });
  }

  assignPlan(data) {
    //console.log("change plan assignPlan data", data);
    // this.setState({
    //   showLoader: true,
    // });
    let postData = {
      userId: this.state.userId ? this.state.userId : "",
      planId: data && data.selectedPlanId ? data.selectedPlanId : "",
      startDate: data && data.startDate ? new Date(data.startDate) : "",
      endDate: data && data.endDate ? new Date(data.endDate) : "",
    };
    //console.log("change plan assignPlan postData", postData);
    this.props.changeBillingPlanAction(postData).then((res) => {
      if (res.status === constant.OK) {
        this.setState({
          showLoader: false,
          billingPlanPrompt: false,
        });
      } else {
        this.setState({
          showLoader: false,
          billingPlanPrompt: false,
        });
        toastMessage(constant.ERROR, message.SOMETHING_WENT_WRONG);
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedPlan !== this.state.selectedPlan) {
      this.searchBuyerAgent(this.state.searchParam);
    }
  }

  Dosearch = (SearchValue) => {
    this.setState({
      filterText: SearchValue,
      selectedPlan: SearchValue.value,
    });
  };

  handleClear = () => {
    this.setState(
      {
        filterText: "",
        searchParam: "",
        selectedPlan: "",
      },
      () => {
        this.search("");
      }
    );

    // if (this.state.filterText === "") {
    //   this.search("");
    // }
  };

  render() {
    let rows = [];

    let buyerAgent = this.state.users || [];
    // console.log('acctowners: ', this.state.users);
    for (var i = 0, len = buyerAgent.length; i < len; i++) {
      let user = buyerAgent[i];
      let accOwnerDsdObj = {};
      if (user.dsd && user.dsd.roles && user.dsd.roles.length > 0) {
        var foundRec = user.dsd.roles.find((x) => x.roleId === "ACCOWNER");
        accOwnerDsdObj = foundRec ? foundRec : {};
      }

      let data = {
        id: user._id,
        name: (
          <Link to={"/UserProfile/" + user._id} className="p-0 text-capitalize">
            {user.firstname} {user.lastname}
          </Link>
        ),
        plan:
          checkObjExists(user.billingUserData) && user.billingUserData.PlanName
            ? user.billingUserData.PlanName
            : "",
        licence:
          checkObjExists(accOwnerDsdObj) && accOwnerDsdObj.brokerLicenseNo
            ? accOwnerDsdObj.brokerLicenseNo
            : "",
        artists: user.accOwnerArtists ?
          user.accOwnerArtists : "0",
        transactions: user.transactions ? (
          user.transactions > 0 ? (
            <Button
              variant="link"
              className="p-0"
              onClick={() => this.goToTransaction(user._id)}
            >
              {" "}
              {user.transactions}
            </Button>
          ) : (
            // user.transactions.length
            "0"
          )
        ) : (
          "0"
        ),
        company:
          checkObjExists(accOwnerDsdObj) &&
          checkObjExists(accOwnerDsdObj.companyInformation) &&
          accOwnerDsdObj.companyInformation.name
            ? accOwnerDsdObj.companyInformation.name
            : "",
        mobile: <PhoneNumber phoneNumber={user.mobileNumber} />,
        email: <div className="email-case">{user.email.address}</div>,
        referralCode:
          checkObjExists(accOwnerDsdObj) && accOwnerDsdObj.referralCode
            ? accOwnerDsdObj.referralCode
            : "",
        currentCredit:
          checkObjExists(user.billingUserData) &&
          user.billingUserData.currentCredit
            ? user.billingUserData.currentCredit
            : "0.00",
        status: !user.isDeleted ? (
          <CheckCircle className="check" style={{ color: "green" }} />
        ) : (
          <CheckCircleOutline className="check-out" />
        ),
        // active: (
        //   <Button
        //     variant="primary"
        //     className={"btn-blue btn-grid "}
        //     disabled={!user.isDeleted}
        //     onClick={() => this.reActivateUser(user._id)}
        //   >
        //     Activate
        //   </Button>
        // ),
        action: !user.isDeleted ? (
          <Dropdown alignRight className="dropdown-action">
            <Dropdown.Toggle
              variant="transparent"
              id="dropdown-folder1"
              className="p-0"
            >
              <MoreHoriz />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                className="color-dark-orange-3 font-14"
                href="javascript:void(0)"
                onClick={() => {
                  this.openDeletePrompt(user._id);
                }}
              >
                Remove
              </Dropdown.Item>
              <Dropdown.Item
                className="color-dark-orange-3 font-14"
                onClick={() => {
                  this.openEditEmailPrompt(user._id, user.email.address);
                }}
              >
                {" "}
                Edit Email
              </Dropdown.Item>
              <Dropdown.Item
                className="color-dark-orange-3 font-14"
                onClick={() => {
                  this.openCreditPrompt(user._id);
                }}
              >
                {" "}
                Update Credit
              </Dropdown.Item>
              <Dropdown.Item
                className="color-dark-orange-3 font-14"
                href="javascript:void(0)"
                onClick={() => {
                  this.requestResetPassword(user.email.address);
                }}
              >
                {" "}
                Reset Password
              </Dropdown.Item>
              <Dropdown.Item
                className="color-dark-orange-3 font-14"
                onClick={() => {
                  this.openChangeBillingPlan(user._id);
                }}
              >
                {" "}
                Change Billing Plan
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        ) : (
          <Dropdown alignRight className="dropdown-action">
            <Dropdown.Toggle
              variant="transparent"
              id="dropdown-folder1"
              className="p-0"
            >
              <MoreHoriz />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                className="color-dark-orange-3 font-14"
                href="javascript:void(0)"
                onClick={() => {
                  this.restoreBuyerAgent(user._id);
                }}
              >
                Restore
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        ),
      };

      rows.push(data);
    }

    let options = [];
    for (var j = 0, len1 = this.state.billingPlan.length; j < len1; j++) {
      let billingPlanData = this.state.billingPlan[j];
      let accOwnerData = {
        label: billingPlanData.PlanName,
        value: billingPlanData._id,
      };
      options.push(accOwnerData);
    }

    return (
      <div>
        <Row className="mx-0 page-head-row page-head-row-big align-items-center">
          <Col>
            <h4 className="title-med mt-0 pt-1">{this.state.showDelete}</h4>
          </Col>
          <Col className="pl-0">
            <ReactSelect
              isClearable={false}
              closeMenuOnSelect={true}
              placeholder={"Select Plan"}
              options={options}
              className="react-select-wrapper react-select-multi react-select-buyer-multi"
              onChange={(e) => this.Dosearch(e)}
              value={this.state.filterText}
            />
          </Col>
          <Col xs="4" align="right">
            <div className="icon-wrapper ml-2">
              <Form.Control
                type="text"
                className="form-control-head"
                placeholder="Search"
                value={this.state.searchParam}
                onChange={(e) => {
                  this.search(e.target.value);
                }}
              />
              <span className="form-control-icn">
                <Search />
              </span>
            </div>
          </Col>
          <Col className="col-auto pl-0 col">
            <Button
              type="button"
              onClick={this.handleClear}
              variant="primary"
              className="btn-blue btn-head"
              style={{ marginRight: "19px" }}
            >
              Clear
            </Button>
          </Col>

          <Col className="col-auto pl-0">
            <Link
              to="/AccountOwner/create"
              className="btn btn-primary btn-blue btn-head w-140"
            >
              Invite Studio Owner
            </Link>
          </Col>
        </Row>

        {this.state.showLoader || this.state.showSpinner ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="dt-content-area">
            <DataTable
              columns={this.columns}
              data={rows}
              sortIcon={<KeyboardArrowDown className="color-grey-1" />}
              noDataComponent={
                <div className="no-transaction no-record no-datatable">
                  <div className="no-transaction-inner">
                    <img src={noRecord} alt="no record" />
                    <p>No Studio Owners Found</p>
                  </div>
                </div>
              }
              highlightOnHover={true}
              className="rdt-requests"
              pagination={true}
              paginationServer={true}
              paginationTotalRows={this.props.totalBuyerAgents}
              paginationPerPage={this.state.recordPerPage}
              onChangePage={(page) => this.changePage(page)}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
            />

            <DeletePrompt
              deletePrompt={this.state.deletePrompt}
              itemId={this.state.userId}
              cancel={() => {
                this.setState({ deletePrompt: false });
              }}
              deleteConfirm={this.removeBuyerAgent}
            />

            {this.state.billingPlanPrompt && (
              <AssignPlanForm
                flag="changePlan"
                userId={this.state.userId}
                billingPlanPrompt={this.state.billingPlanPrompt}
                cancel={() => {
                  this.setState({ billingPlanPrompt: false });
                }}
                assignPlan={this.assignPlan}
              />
            )}

            <Modal
              show={this.state.creditPrompt}
              onHide={() =>
                this.setState({ creditPrompt: !this.state.creditPrompt })
              }
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med"
              backdrop={false}
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">
                  Update Credit
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="pb-0">
                <Formik
                  onSubmit={() => {
                    this.setState({ showLoader: true });
                    var postData = {
                      userId: this.state.userId,
                      currentcredit: this.state.currentCredit,
                    };
                    this.props
                      .updateCurrentCreditAction(postData)
                      .then((res) => {
                        this.setState({
                          showLoader: false,
                          creditPrompt: !this.state.creditPrompt,
                        });
                      })
                      .catch((err) => {
                        this.setState({
                          showLoader: false,
                          creditPrompt: !this.state.creditPrompt,
                        });
                      });
                  }}
                >
                  {({ values, onChange, handleSubmit }) => (
                    <Form onSubmit={handleSubmit}>
                      <label
                        htmlFor="currentCredit"
                        className="form-label mb-2"
                      >
                        Credit
                      </label>
                      <NumericInput
                        precision={2}
                        step={0.1}
                        min={0} // Prevent negative values
                        name="currentCredit"
                        inputMode="numeric"
                        strict
                        style={false}
                        className="form-control"
                        value={this.state.currentCredit}
                        onChange={(e) =>
                          this.setState({
                            currentCredit: e,
                          })
                        }
                      />
                      <ErrorMessage
                        name="currentCredit"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                      <Button
                        type="submit"
                        variant="primary"
                        className="btn-blue w-140 mt-3 mb-3"
                      >
                        Save
                      </Button>
                    </Form>
                  )}
                </Formik>
              </Modal.Body>
            </Modal>

            <Modal
              show={this.state.editPrompt}
              onHide={() =>
                this.setState({ editPrompt: !this.state.editPrompt })
              }
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med"
              backdrop={false}
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">
                  Edit Contact
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="pb-0">
                <Formik
                  initialValues={this.state.form}
                  validate={(values) => {
                    const errors = {};
                    if (!values.email) {
                      errors.email = "Please enter Email Address";
                    } else if (
                      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                        values.email
                      )
                    ) {
                      errors.email = "Please enter valid Email address";
                    }
                    return errors;
                  }}
                  onSubmit={(values) => {
                    this.setState({ showLoader: true });
                    this.props
                      .updateBuyerUserAction(values)
                      .then((res) => {
                        this.getBuyerAgentList(this.state.page);
                        this.setState({
                          editPrompt: !this.state.editPrompt,
                        });
                      })
                      .catch((err) => {
                        this.setState({
                          showLoader: false,
                          editPrompt: !this.state.editPrompt,
                        });
                      });
                  }}
                >
                  {({ values, onChange, handleSubmit }) => (
                    <Form onSubmit={handleSubmit}>
                      <label htmlFor="email" class="form-label mb-2">
                        Email ID<span className="text-danger">*</span>
                      </label>
                      <Field
                        onChange={(e) => this.onEditEmail(e)}
                        type="email"
                        name="email"
                        className="form-control mb-1"
                        id="email"
                        value={values.email}
                        placeholder="name@example.com"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                      <Button
                        type="submit"
                        variant="primary"
                        className="btn-blue w-140 mt-3 mb-3"
                      >
                        Save
                      </Button>
                    </Form>
                  )}
                </Formik>
              </Modal.Body>
            </Modal>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    buyerAgents: state.reducer.buyerAgents,
    status: state.reducer.status,
    totalBuyerAgents: state.reducer.totalBuyerAgents,
    forgotsuccess: state.reducer.forgotsuccess,
  };
};

export default connect(
  mapStateToProps,
  {
    buyerAgentsAction,
    getAllOwnersData,
    removeUsersAction,
    forgotPasswordAction,
    updateBuyerUserAction,
    reActivateDeletedUserAction,
    searchUserAction,
    changeBillingPlanAction,
    getCurrentCreditAction,
    updateCurrentCreditAction,
    getbillingPlans,
    restoreUsersAction,
  }
)(BuyerAgent);
